'use client';

import { Spinner } from '@kintsugi/ui';
import { Box, Toaster as ChakraToaster, Portal, Toast } from '@chakra-ui/react';
import { getToastBgColor, toaster } from './toaster-instance';
import { FiAlertCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';

const getToastIcon = (type?: string) => {
  switch (type) {
    case 'loading':
      return <Spinner size="sm" color="blue.solid" />;
    case 'success':
      return <FiCheckCircle color="#38A169" size={20} />;
    case 'info':
      return <FiInfo color="#4285F4" size={20} />;
    case 'error':
      return <FiAlertCircle color="#E53E3E" size={20} />;
    default:
      return <Toast.Indicator />;
  }
};

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {toast => (
          <Toast.Root width="max-content" maxWidth="520px" bg={getToastBgColor(toast.type)} gap="3" alignItems="center">
            <Box>{getToastIcon(toast.type)}</Box>
            <Box>
              {toast.title && !toast.description && <Toast.Description lineClamp={3}>{toast.title}</Toast.Description>}
              {toast.title && toast.description && <Toast.Title fontWeight="semibold">{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description lineClamp={4}>{toast.description}</Toast.Description>}
            </Box>
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
